// extracted by mini-css-extract-plugin
module.exports = {"table":"LogItem_table__3gqk9","row":"LogItem_row__36nyE","head":"LogItem_head__1dUQd","td":"LogItem_td__2-f5Q","th":"LogItem_th__s4BX6"};